import { http } from "./Http";

// AM1801
export const GetDocumentFormListAPI = (config: any) => {
  const { baseURL, affiliate_cd, token } = config;
  const param = {
    token: token,
    url: `${baseURL}/v1/document_forms/${affiliate_cd}`,
    config: config,
  };
  return http(param);
};
